import React from "react";
import { InputFile } from "../file-classes";
import { ReactComponent as Default } from "./file-regular.svg";
import { ReactComponent as Image } from "./file-image-regular.svg";
import { ReactComponent as Pdf } from "./file-pdf-regular.svg";

const extensions = {
    jpg: <Image />,
    jpeg: <Image />,
    pdf: <Pdf />,
    png: <Image />
};

export default ({ file }) =>
    (file && extensions[new InputFile(file).extension]) || <Default />;
